import React, { useEffect, useState } from 'react'
import { useAuth } from 'hooks/auth'
import { useParams } from 'react-router-dom'
import Information from 'views/profile/components/information'
import api from 'helpers/api'
import { IUserObject } from 'types'
import ResourceDeleted from 'views/auth/views/resourceDeleted'

const Profile: React.FC = () => {
  const { userId } = useParams<{ userId: string; tab: string }>()
  const userID = userId ?? ''
  const [userData, setUserData] = useState<IUserObject>()
  const [statusCode, setStatusCode] = useState<number>(200)
  useEffect(() => {
    if (!userID) return
    setUserData(undefined)
    api
      .getUser(userID)
      .then((response) => {
        setUserData(response.data)
        document.title = `${response.data.name}`
      })
      .catch((error) => {
        setStatusCode(error.rawCode)
      })
  }, [userID])

  const { user, updateUser } = useAuth()

  const ownProfile = user && user.firebaseUserId === userID ? true : false

  // Returns the promise so the caller (EditInfoModal) can await the save and
  // surface a validation failure instead of it becoming an unhandled rejection
  // (Sentry WEBAPP-B: "There were validation errors" — issue #10140).
  const localUpdateUser = async (data: IUserObject): Promise<void> => {
    const response = await api.updateUserProfile({
      name: data.name,
      bio: data.bio,
      linkedin: data.linkedin,
      twitter: data.twitter,
      university: data.university,
      universityDegree: data.universityDegree,
      profilePicture: data.profilePicture,
      organisation: data.organisation,
      location: data.location,
      website: data.website
    })
    setUserData(response.data)
    await updateUser(response.data)
  }

  return (
    <div className="flex flex-col h-full w-full select-none bg-surface overflow-auto">
      <div className="flex w-full py-0 px-[30px]">
        {statusCode === 404 ? (
          <ResourceDeleted />
        ) : (
          <Information updateUser={localUpdateUser} ownProfile={ownProfile} userInfo={userData} />
        )}
      </div>
    </div>
  )
}

export default Profile
